import React from 'react';
import { connect } from 'react-redux';

import {
  changeColor,
  changeWidth,
  changeVerticalPadding,
} from '../actions/divider-element-actions';

import styles from '../../../../stylesheet/css/header-builder/divider-element-options.css';

export const DividerElementOptions = ({
  onColorChange,
  onWidthChange,
  onVerticalPaddingChange,
  options = {}
}) => {
  const { color, width, verticalPadding } = options;

  const handleColorChange = e => onColorChange(e.target.value);
  const handleWidthChange = e => onWidthChange(e.target.value);
  const handleVerticalPaddingChange = e => onVerticalPaddingChange(e.target.value);

  return (
    <div>
      <header>Color:</header>
      <input type="color" value={color} onChange={handleColorChange} />

      <header>Divider Width:</header>
      <input type="text" value={width} onChange={handleWidthChange} />

      <header>Vertical Padding:</header>
      <input type="text" value={verticalPadding} onChange={handleVerticalPaddingChange} />
    </div>
  );
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { device, id } = ownProps;

  return {
    onColorChange(value) {
      dispatch(changeColor({ device, id, value }));
    },

    onWidthChange(value) {
      dispatch(changeWidth({ device, id, value }));
    },

    onVerticalPaddingChange(value) {
      dispatch(changeVerticalPadding({ device, id, value }));
    },
  };
};

export default connect(
  null,
  mapDispatchToProps
)(DividerElementOptions);



// WEBPACK FOOTER //
// ./app/header-builder/components/DividerElementOptions.js